import http from "./http";

/**
 * Gộp lệnh Wise theo BÊN KÝ (B3 chuỗi, Quân chốt 17/10/2026).
 * Backend: whalelo-backend/modules/payout-batch (README.md giải thích luật gộp).
 */

export interface BatchItem {
	requestId: number;
	partnerId: number;
	partnerName: string;
	amount: number;
	currency: string;
	nguonNguoiNhan: "tram" | "cung-ben-ky" | null;
}
export interface BatchGroup {
	legalEntityId: number;
	legalName: string | null;
	currency: string;
	wiseRecipientId: number;
	requestIds: number[];
	targetTotal: number;
	items: BatchItem[];
}
export interface BatchRow {
	id: number;
	legalEntityId: number;
	targetCurrency: string;
	targetTotal: number;
	sourceTotal: number | null;
	wiseFee: number | null;
	itemCount: number;
	status: string;
	wiseStatus: string | null;
	reference: string | null;
	createdAt: string;
}

export const getBatchConfig = async () => (await http.get(`/admin/payout-batches/config`)).data as { enabled: boolean };
export const setBatchConfig = async (enabled: boolean) =>
	(await http.put(`/admin/payout-batches/config`, { enabled })).data as { enabled: boolean };
export const getEligibleGroups = async () =>
	(await http.get(`/admin/payout-batches/eligible`)).data as { config: { enabled: boolean }; groups: BatchGroup[] };
export const listBatches = async () => ((await http.get(`/admin/payout-batches`)).data?.docs || []) as BatchRow[];
export const createBatch = async (requestIds: number[]) =>
	(await http.post(`/admin/payout-batches`, { requestIds })).data as {
		batchId: number;
		reference: string;
		itemCount: number;
		targetTotal: number;
		currency: string;
		sourceTotal: number;
		fee: number;
	};
export const refreshBatch = async (id: number) => (await http.post(`/admin/payout-batches/${id}/refresh`, {})).data;

export const apiErrorText = (e: unknown): string => {
	const r = (e as { response?: { data?: { message?: string; code?: string } } })?.response?.data;
	return r?.message || r?.code || (e as Error)?.message || "Request failed";
};
